/** Only the picked people: Teams supplies the signed-in user itself. Keep @ and separators literal. */
export function teamsChatLink(addresses: readonly string[], topic: string, message: string): string {
  const users = addresses.map((address) => encodeURIComponent(address).replace(/%40/g, '@')).join(',');
  return `https://teams.microsoft.com/l/chat/0/0?users=${users}`
    + (topic ? `&topicName=${encodeURIComponent(topic)}` : '')
    + (message ? `&message=${encodeURIComponent(message)}` : '');
}
